import imageSizes from '../imageSizes.js';
import getScaledImageSource from '../getScaledImageSource/getScaledImageSource';
export default function getSrcSet(src, sizes) {
  const srcSet = sizes.reduce((acc, size) => {
    // Add srcSet definition if supplied
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!size) {
      // use for imageSizes or specific sizes
      const dimensions = typeof size === 'string' ? imageSizes[size] : {
        width: size?.width,
        height: size?.height
      };
      const imgSrc = getScaledImageSource({
        src,
        ...dimensions
      });
      acc.push(`${imgSrc} ${dimensions.width}w`);
    }
    return acc;
  }, []);
  return srcSet.join(', ');
}